// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ff4b4c06","171":"14e13b03","453":"7e513c49"}[chunkId] + ".chunk.js";
};